import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _createForOfIteratorHelper from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp, loadMoreList, packageData } from "@/mixins/index";
import AdvertisingSDKManagement from "../advertisingSDKManagement.vue";
export default {
  mixins: [popUp, loadMoreList, packageData],
  data: function data() {
    return {
      dialogFormVisible: false,
      activeStep: 0,
      iconList: [],
      typeArrayValue: 'map',
      timing: [{
        label: '否',
        value: 2
      }, {
        label: '是',
        value: 1
      }],
      typeArrayList: [{
        label: "字典",
        value: "map"
      }],
      formData: {
        step1: {
          game_group_id: "",
          original_package_type_id: "",
          app_id: "",
          original_package_id: "",
          is_delay: "",
          delay_time: "",
          icon: "",
          icon_path: ""
        },
        step2: {
          params: []
        },
        otherParams: {
          game: "",
          platform: "",
          channel: "",
          pkg: "",
          ad_channel: "",
          ad_placement: ""
        },
        sdkParams: {
          sdkType: '',
          sdk_download_url: '',
          params: [],
          advSdkType: '',
          advSdkTypeAll: '',
          adv_sdk_url_ver: '',
          adv_sdk_url: '',
          adv_sdk_version: '',
          advertisingParams: [],
          key_store: {
            path: '',
            store_pass: '',
            key_pass: '',
            alias: ''
          },
          oaid_cert_download_url: '',
          reportListName: "report_params_list",
          reportData: [],
          checkReportParams: [],
          sora_quick_id: ''
        }
      },
      tip: '',
      chooseStatus: [],
      otherSdkTypeList: [],
      otherSdkList: [],
      adChannelSdkTypeList: [],
      adChannelSdkManageList: [],
      sdkPemManageList: [],
      reportConfigList: [],
      appList: [],
      oaidConfigManageList: [],
      advSdkType: '',
      sdk_type: '',
      sdk_pem_type: '',
      rules: {
        step1: {
          game_group_id: [{
            required: true,
            message: "请选择游戏组",
            trigger: "blur"
          }],
          app_id: [{
            required: true,
            message: "请选择应用列表",
            trigger: "blur"
          }],
          original_package_type_id: [{
            required: true,
            message: "请选择母包类型",
            trigger: "blur"
          }],
          original_package_id: [{
            required: true,
            message: "请选择母包",
            trigger: "blur"
          }],
          icon: [{
            required: true,
            message: "请上传图标",
            trigger: "blur"
          }],
          is_delay: [{
            required: true,
            message: "请选择定时发送",
            trigger: "blur"
          }],
          delay_time: [{
            required: true,
            message: "请选择发送时间",
            trigger: "blur"
          }]
        },
        step2: {
          params: [{
            required: true,
            message: "请添加参数",
            trigger: "blur"
          }],
          value: [{
            required: true,
            message: "请输入参数",
            trigger: "blur"
          }]
        },
        otherParams: {
          game: [{
            required: true,
            message: "请输入游戏标志符",
            trigger: "blur"
          }],
          platform: [{
            required: true,
            message: "请输入平台标志符",
            trigger: "blur"
          }],
          channel: [{
            required: true,
            message: "请输入渠道标志符",
            trigger: "blur"
          }],
          pkg: [{
            required: true,
            message: "请输入包名",
            trigger: "blur"
          }],
          ad_channel: [{
            required: true,
            message: "请输入广告渠道",
            trigger: "blur"
          }],
          ad_placement: [{
            required: true,
            message: "请输入广告位置",
            trigger: "blur"
          }]
        }
      }
    };
  },
  created: function created() {},
  watch: {
    'formData.sdkParams.sdkType': function formDataSdkParamsSdkType(val) {
      if (val) {
        console.log("val===", val);
        this.getSDK(val, true);
      }
    },
    'formData.sdkParams.advSdkType': function formDataSdkParamsAdvSdkType(val1) {
      if (val1) {
        this.getAdverSDK(val1, true);
      }
    },
    "formData.sdk_pem_type": function formDataSdk_pem_type(val2) {
      if (val2) {
        this.getSDKNew(val2, true);
      }
    }
  },
  methods: {
    init: function init(data, isCopy) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var datas, list, newParams, key, otherList, paramslist, newData, j, step2Data, commaIndex, key_store;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.getcommonDataNew(['otherSdkTypeList']);

                _this.getcommonDataNew(['adChannelSdkTypeList']); // this.getcommonData(['sdkPemManageList'])


                _this.getcommonDataNew(['oaidConfigManageList', 'reportConfigList']);

                _this.getcommonDataNew(['gameGroupList', 'originPkgList', 'originPkgTypeList', 'iconList', "appList"]); //初始化


                _this.activeStep = 0;
                _this.chooseStatus = [];
                _this.formData = {
                  id: "",
                  step1: {
                    game_group_id: "",
                    original_package_type_id: "",
                    original_package_id: "",
                    app_id: "",
                    is_delay: "",
                    delay_time: "",
                    icon: "",
                    icon_path: ""
                  },
                  step2: {
                    params: []
                  },
                  otherParams: {
                    game: "",
                    platform: "",
                    channel: "",
                    pkg: "",
                    ad_channel: "",
                    ad_placement: ""
                  },
                  sdkParams: {
                    sdkType: '',
                    sdk_download_url: '',
                    params: [],
                    advSdkType: '',
                    adv_sdk_url_ver: '',
                    adv_sdk_url: '',
                    adv_sdk_version: '',
                    advertisingParams: [],
                    oaid_cert_download_url: '',
                    key_store: {
                      path: '',
                      store_pass: '',
                      key_pass: '',
                      alias: ''
                    },
                    reportListName: "report_params_list",
                    reportData: [],
                    checkReportParams: [],
                    sora_quick_id: ''
                  },
                  copyPramsKeyData: []
                };
                _this.imgList = [];
                _this.tip = ''; //赋值

                if (data) {
                  datas = JSON.parse(JSON.stringify(data));
                  list = [];
                  newParams = JSON.parse(data.params);

                  for (key in newParams["unity_params"]) {
                    list.push({
                      label: key,
                      value: newParams["unity_params"][key]
                    });
                  }

                  otherList = [];
                  paramslist = [];
                  _this.otherSdkList = [];
                  _this.adChannelSdkManageList = [];
                  otherList = list;
                  Object.keys(_this.formData.step1).forEach(function (key) {
                    _this.formData.step1[key] = datas[key];
                  }); // this.formData.step1.icon = datas.icon

                  Object.keys(_this.formData.step2).forEach(function (key) {
                    _this.formData.step2[key] = datas[key];
                  });
                  _this.formData.id = datas.id;
                  Object.keys(_this.formData.otherParams).forEach(function (key) {
                    _this.formData.otherParams[key] = otherList.find(function (item) {
                      return item.label == key;
                    }).value;
                  });
                  _this.formData.sdk_pem_type = datas.sdk_pem_type;
                  newData = {};

                  for (j in newParams) {
                    if (j != "unity_params" && j != "adv_config" && j != "key_store" && j != "platform_params" && j != "sdk_download_url" && j != "oaid_cert_download_url" && j != "icon" && j != "game_pkg_download_url" && j != "sdk_app_id" && j != "sdk_secret_id" && j != "report_params_list" && j != "sora_quick_id") {
                      newData[j] = newParams[j];
                    }
                  }

                  step2Data = _this.$utils.transformObject(newData);
                  _this.formData.step2.params = step2Data; //三方SDK

                  console.log("newParams===", newParams);

                  if (newParams.platform_params) {
                    _this.formData.sdkParams.params = _this.$utils.transformObject(JSON.parse(newParams.platform_params));
                  }

                  _this.formData.sdkParams.sdkType = datas.sdkType;
                  _this.formData.sdkParams.sdk_download_url = newParams.sdk_download_url; //广告SDK

                  if (newParams.adv_config && newParams.adv_config.platform_params) {
                    _this.formData.sdkParams.advertisingParams = _this.$utils.transformObject(JSON.parse(newParams.adv_config.platform_params));
                  }

                  _this.formData.sdkParams.advSdkType = datas.advSdkType || '';
                  _this.formData.sdkParams.adv_sdk_url_ver = datas.adv_sdk_url_ver || '';

                  if (_this.formData.sdkParams.adv_sdk_url_ver) {
                    commaIndex = _this.formData.sdkParams.adv_sdk_url_ver.indexOf(',');
                    _this.formData.sdkParams.adv_sdk_url = _this.formData.sdkParams.adv_sdk_url_ver.substring(0, commaIndex);
                    _this.formData.sdkParams.adv_sdk_version = _this.formData.sdkParams.adv_sdk_url_ver.substring(commaIndex + 1);
                  } //打包签名文件


                  key_store = {
                    path: '',
                    store_pass: '',
                    key_pass: '',
                    alias: ''
                  };
                  _this.formData.sdkParams.key_store = newParams.key_store || key_store; //oaid文件列表

                  _this.formData.sdkParams.oaid_cert_download_url = newParams.oaid_cert_download_url || ''; //上报参数

                  _this.formData.sdkParams.checkReportParams = datas.report_check_item ? datas.report_check_item.split(",").map(Number) : [];

                  if (newParams.report_params_list) {
                    _this.formData.sdkParams.reportData = _this.$utils.convertToOriginalFormat(newParams.report_params_list);
                  } //一键登录


                  _this.formData.sdkParams.sora_quick_id = newParams.sora_quick_id || '';
                  _this.formData.step1.delay_time = _this.dateStringToTimestamp(_this.formData.step1.delay_time);
                  _this.chooseStatus = data.chooseStatus ? data.chooseStatus.split(",") : [];
                  console.log("this.formData.sdkParams", _this.formData.sdkParams); // this.chooseStatus = 2;
                }

                if (isCopy) {
                  _this.formData.id = "";
                }

                _this.dialogFormVisible = true;

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getType: function getType(type) {
      // this.chooseStatus = type;
      var index = this.chooseStatus.indexOf(type);

      if (index == -1) {
        this.chooseStatus.push(type);
      } else {
        this.chooseStatus.splice(index, 1);
      }
    },
    getReportParams: function getReportParams(data) {
      var _this2 = this;

      var getParams = []; // this.formData.sdkParams.reportData = this.$utils.convertToOriginalFormat(JSON.parse(data));

      if (data.length) {
        var _ref;

        data.forEach(function (item) {
          _this2.reportConfigList.forEach(function (a) {
            if (item == a.id) {
              getParams.push(_this2.$utils.convertToOriginalFormat(JSON.parse(a.params)));
            }
          });
        });
        this.formData.sdkParams.reportData = (_ref = []).concat.apply(_ref, getParams);
      } else {
        this.formData.sdkParams.reportData = [];
      }
    },
    getSDK: function getSDK(type, isTrue) {
      var _this3 = this;

      this.otherSdkList = [];

      if (type) {
        var newType = type.split("、");
        this.$api.otherSdkManageList({
          sdk_type_id: newType[0]
        }).then(function (res) {
          _this3.otherSdkList = res.data.data;
        });

        if (!isTrue) {
          this.formData.sdkParams.sdk_download_url = ""; //获取对应的SDK类型参数

          var params = JSON.parse(newType[2]);
          this.formData.sdkParams.params = this.$utils.transformObject(params);
        }
      } else {
        this.otherSdkList = [];
        this.formData.sdkParams.params = "";
      }
    },
    getSDKNew: function getSDKNew(type, isTrue) {
      var _this4 = this;

      this.sdkPemManageList = [];

      if (!isTrue) {
        this.formData.sdkParams.key_store.path = '';
        this.formData.sdkParams.key_store.store_pass = '';
        this.formData.sdkParams.key_store.key_pass = '';
        this.formData.sdkParams.key_store.alias = '';
      }

      this.$api.sdkPemManageList({
        sdk_type_id: type.split("、")[0]
      }).then(function (res) {
        _this4.sdkPemManageList = res.data.data;
      });
    },
    getAdverSDK: function getAdverSDK(type, isTrue) {
      var _this5 = this;

      this.adChannelSdkManageList = [];

      if (type) {
        var newType = type.split("、");
        this.formData.sdkParams.advSdkTypeAll = type;
        this.$api.adChannelSdkManageList({
          sdk_type_id: newType[0]
        }).then(function (res) {
          _this5.adChannelSdkManageList = res.data.data;
        });

        if (!isTrue) {
          this.formData.sdkParams.adv_sdk_url_ver = ""; //获取对应的广告SDK类型参数

          this.advSdkType = newType[1];
          var params = JSON.parse(newType[2]);
          console.log("params===", params);
          this.formData.sdkParams.advertisingParams = this.$utils.transformObject(params);
        }
      } else {
        this.adChannelSdkManageList = [];
        this.formData.sdkParams.advertisingParams = "";
      }
    },
    getAdverSDKUrlVer: function getAdverSDKUrlVer(type) {
      var commaIndex = type.indexOf(',');
      this.formData.sdkParams.adv_sdk_url = type.substring(0, commaIndex);
      this.formData.sdkParams.adv_sdk_version = type.substring(commaIndex + 1);
    },
    getPacking: function getPacking(path) {
      var paskItem = this.sdkPemManageList.filter(function (item) {
        return item.sdk_pem_url == path;
      });

      if (paskItem.length) {
        // this.formData.sdkParams.key_store.path = paskItem[0].sdk_pem_url;
        var packPrams = JSON.parse(paskItem[0].params);
        var store_pass = packPrams.store_pass,
            alias = packPrams.alias,
            key_pass = packPrams.key_pass;
        this.formData.sdkParams.key_store.store_pass = store_pass;
        this.formData.sdkParams.key_store.alias = alias;
        this.formData.sdkParams.key_store.key_pass = key_pass;
      }
    },
    getcommonData: function getcommonData() {
      var _arguments = arguments,
          _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var reqList, _iterator, _step, i, res;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                reqList = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : [];
                _iterator = _createForOfIteratorHelper(reqList);
                _context2.prev = 2;

                _iterator.s();

              case 4:
                if ((_step = _iterator.n()).done) {
                  _context2.next = 12;
                  break;
                }

                i = _step.value;
                _context2.next = 8;
                return _this6.$api[i]({
                  pageSize: 1000
                });

              case 8:
                res = _context2.sent;
                _this6[i] = res.data.data;

              case 10:
                _context2.next = 4;
                break;

              case 12:
                _context2.next = 17;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](2);

                _iterator.e(_context2.t0);

              case 17:
                _context2.prev = 17;

                _iterator.f();

                return _context2.finish(17);

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 14, 17, 20]]);
      }))();
    },
    clearData: function clearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.$refs.step1Form && this.$refs.step1Form.clearValidate();
      this.$refs.step2Form && this.$refs.step2Form.clearValidate();
    },
    finish: function finish() {
      this.dialogFormVisible = false;
    },
    dateStringToTimestamp: function dateStringToTimestamp(dateString) {
      // 创建一个新的Date对象
      var date = new Date(dateString); // 获取时间戳（毫秒）

      var timestamp = date.getTime();
      return timestamp;
    },
    pkgTypeChange: function pkgTypeChange() {
      var _this7 = this;

      this.$api.originPkgTypeDetail({
        id: this.formData.step1.original_package_type_id
      }).then(function (res) {
        if (res.status == 200) {
          var list = res.data.param_keys ? JSON.parse(res.data.param_keys) : [];

          if (list.unity_params) {
            _this7.formData.otherParams.game = list.unity_params.game || '';
            _this7.formData.otherParams.platform = list.unity_params.platform || '';
            _this7.formData.otherParams.channel = list.unity_params.channel || '';
            _this7.formData.otherParams.pkg = list.unity_params.pkg || '';
            _this7.formData.otherParams.ad_channel = list.unity_params.ad_channel || '';
            _this7.formData.otherParams.ad_placement = list.unity_params.ad_placement || '';
          }

          var newList = {};

          for (var i in list) {
            if (i != 'unity_params') {
              newList[i] = list[i];
            }
          }

          _this7.formData.step2.params = _this7.$utils.transformObject(newList);
        }
      });
    },
    nextStep: function nextStep() {
      var _this8 = this;

      var formRef = "step".concat(this.activeStep + 1, "Form"); //表单验证逻辑

      if (this.activeStep === 0) {
        this.$refs[formRef].validate(function (valid) {
          if (valid) {
            _this8.activeStep++;
          } else {
            _this8.$message.error('请将参数填写完整');

            return;
          }
        });
      } else if (this.activeStep === 1) {
        this.$refs.step3Form.validate(function (valid) {
          if (valid) {
            _this8.activeStep++;
          } else {
            _this8.$message.error('请将参数填写完整');

            return;
          }
        });
      } else {
        //新增打包任务
        if (this.activeStep == 2) {
          this.dataFormSubmit();
        }
      }
    },
    prevStep: function prevStep() {
      if (this.activeStep > 0) this.activeStep--;
    },
    addArrayData: function addArrayData() {
      this.formData.sdkParams.reportData.push({
        reportKey: 'channel_name',
        reportVal: '',
        arrayData: []
      });
    },
    addArrayItemData: function addArrayItemData(index) {
      this.formData.sdkParams.reportData[index].arrayData.push({
        key: "",
        value: ""
      });
    },
    removeItemContent: function removeItemContent(index) {
      this.formData.sdkParams.reportData.splice(index, 1);
    },
    removeArrayItem: function removeArrayItem(index, idx) {
      this.formData.sdkParams.reportData[index].arrayData.splice(idx, 1);
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var data, step1Data, step2Data, PramsKeyData, paramsData, d, otherParams, game_pkg_download_url, newType, appData, sdk_download_url, platform_params, SDKParams, adv_config, advSDKParams, key_store, repoer_data, dataNew, reqFn;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                data = JSON.parse(JSON.stringify(_this9.formData));

                if (!_this9.formData.id) {
                  _context3.next = 4;
                  break;
                }

                _context3.next = 4;
                return _this9.secondConfirmation();

              case 4:
                step1Data = data.step1;
                step2Data = data.step2;
                PramsKeyData = JSON.parse(JSON.stringify(step2Data.params));
                _context3.next = 9;
                return _this9.$utils.dealTypeData(PramsKeyData);

              case 9:
                _this9.copyPramsKeyData = _context3.sent;
                _context3.next = 12;
                return _this9.$utils.mergeData(_this9.copyPramsKeyData);

              case 12:
                _this9.copyPramsKeyData = _context3.sent;
                paramsData = Object.assign({}, step1Data, {
                  id: _this9.formData.id
                }, {
                  params: []
                });
                Object.keys(_this9.formData.otherParams).forEach(function (key) {
                  paramsData.params.push({
                    label: key,
                    value: _this9.formData.otherParams[key]
                  });
                });
                d = {
                  unity_params: {}
                };
                paramsData.params.forEach(function (item, index) {
                  d.unity_params[item.label] = item.value;
                });
                otherParams = {};
                otherParams.icon = step1Data.icon;
                game_pkg_download_url = _this9.originPkgList.filter(function (item) {
                  return item.id == step1Data.original_package_id;
                });
                otherParams.game_pkg_download_url = game_pkg_download_url[0].package_path;

                if (data.sdkParams.sdkType) {
                  // const commonIndex = data.sdkParams.sdkType.indexOf(',');
                  newType = data.sdkParams.sdkType.split("、");
                  otherParams.platform = newType[1] || '';
                }

                appData = _this9.appList.filter(function (item) {
                  return item.id == step1Data.app_id;
                });

                if (appData.length) {
                  otherParams.sdk_app_id = appData[0].appid;
                  otherParams.sdk_secret_id = appData[0].appsecret;
                  otherParams.package_name = appData[0].pkg;
                } //处理SDK数据
                //三方SDK


                if (!_this9.chooseStatus.includes("third")) {
                  _context3.next = 34;
                  break;
                }

                sdk_download_url = data.sdkParams.sdk_download_url;
                platform_params = '';

                if (!data.sdkParams.params.length) {
                  _context3.next = 32;
                  break;
                }

                _context3.next = 30;
                return _this9.$utils.dealTypeData(data.sdkParams.params);

              case 30:
                SDKParams = _context3.sent;
                platform_params = JSON.stringify(_this9.$utils.mergeData(SDKParams));

              case 32:
                otherParams.sdk_download_url = sdk_download_url;
                otherParams.platform_params = platform_params;

              case 34:
                if (!_this9.chooseStatus.includes("adversting")) {
                  _context3.next = 48;
                  break;
                }

                adv_config = {};
                adv_config.platform = _this9.advSdkType || _this9.formData.sdkParams.advSdkTypeAll.split("、")[1];
                adv_config.version = data.sdkParams.adv_sdk_version;
                adv_config.download_url = data.sdkParams.adv_sdk_url;

                if (!data.sdkParams.advertisingParams.length) {
                  _context3.next = 46;
                  break;
                }

                _context3.next = 42;
                return _this9.$utils.dealTypeData(data.sdkParams.advertisingParams);

              case 42:
                advSDKParams = _context3.sent;
                adv_config.platform_params = JSON.stringify(_this9.$utils.mergeData(advSDKParams));
                _context3.next = 47;
                break;

              case 46:
                adv_config.platform_params = "";

              case 47:
                otherParams.adv_config = adv_config;

              case 48:
                //打包签名文件
                if (_this9.chooseStatus.includes("packing")) {
                  key_store = data.sdkParams.key_store;
                  otherParams.key_store = key_store;
                } //处理oaid数据


                if (_this9.chooseStatus.includes("oaid")) {
                  otherParams.oaid_cert_download_url = data.sdkParams.oaid_cert_download_url;
                } //一键登录


                otherParams.sora_quick_id = data.sdkParams.sora_quick_id || ''; //处理上传数据

                if (data.sdkParams.reportData.length) {
                  repoer_data = _this9.$utils.convertFormat(data.sdkParams.reportData);
                  otherParams.report_params_list = repoer_data;
                }

                dataNew = Object.assign({}, _this9.copyPramsKeyData, d, otherParams);
                paramsData.params = JSON.stringify(dataNew);
                paramsData.delay_time = paramsData.delay_time ? paramsData.delay_time / 1000 : 0; //存储SDK里面下拉框的值

                paramsData.sdkType = data.sdkParams.sdkType;
                paramsData.advSdkType = data.sdkParams.advSdkTypeAll || data.sdkParams.advSdkType;
                paramsData.adv_sdk_url_ver = data.sdkParams.adv_sdk_url_ver;
                paramsData.sdk_pem_type = data.sdk_pem_type;
                paramsData.report_check_item = data.sdkParams.checkReportParams.length ? data.sdkParams.checkReportParams.join(",") : ''; //三方SDk，广告SDk，打包签名文件按钮选择

                if (_this9.chooseStatus.length) {
                  paramsData.chooseStatus = _this9.chooseStatus.join(",");
                }

                reqFn = data.id ? 'operationUpdate' : 'operationAdd';

                _this9.$api[reqFn](paramsData).then(function (res) {
                  if (res.status == 200) {
                    _this9.tip = "添加成功";

                    _this9.$message({
                      message: '操作成功',
                      type: 'success'
                    });

                    _this9.dialogFormVisible = false;

                    _this9.$emit('change');
                  } else {
                    _this9.tip = res.message;
                  }

                  _this9.activeStep++;
                });

              case 63:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};